// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1_VEF","empty":"ModalGraph_empty__UWazj"};